import { LoggingService } from './../shared/services/logging.service'
import { ErrorHandler, Injectable, Injector } from '@angular/core'

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  constructor(
    private injector: Injector,
    private loggingService: LoggingService
  ) {}

  public handleError(error: Error) {
    this.loggingService.reportError(error)
  }
}
